import {
    agentProductionTerms,
    marketDynamicsTerms,
    marketShareTerms,
    moduleNames,
    modules,
    searchTerms,
    searchTypes,
    navTerms,
    searchRoutes as rt
} from '../../constants';
import { terms } from '../../dashboard/constants/index';
import { appNames, runningApp } from '../../constants/app';
import { helpItemLabels, navigateToLogout, talentTerms, TALENT_MARKETING_URL } from '../../constants/nav';
import { Routes } from '../routes/routes';
import { getEndpoint, TALENT } from '../../providers/endpoint.provider';
import { BMT_APP_KEY } from '../../constants/auth';

const talentUrl = `${getEndpoint(TALENT)}/auth`;

const getProficiencyMetricsNavItemsByApp = (navTo) => ({
    [appNames.XAM]: undefined,
    [appNames.XBM]: {
        label: agentProductionTerms.proficiencyMetrics,
        menuItems: [
            { label: searchTerms.searchBy, header: true },
            {
                label: searchTypes[rt.transactions].title,
                onClick: () => {
                    navTo(
                        rt.transactions,
                        modules.proficiencyMetrics.transactions
                    );
                },
                activePathname: rt.transactions
            },
            {
                label: searchTypes[rt.officeName].title,
                onClick: () => navTo(
                    rt.officeName,
                    modules.proficiencyMetrics.offices
                ),
                activePathname: rt.officeName
            },
            {
                label: searchTypes[rt.agentName].title,
                onClick: () => navTo(
                    rt.agentName,
                    modules.proficiencyMetrics.agents
                ),
                activePathname: rt.agentName
            },
            {
                label: searchTypes[rt.agentMovement].title,
                onClick: () => navTo(
                    rt.agentMovement,
                    modules.proficiencyMetrics.agentMovement
                ),
                activePathname: rt.agentMovement
            },
            {
                label: searchTypes[rt.savedAgents].title,
                onClick: () => navTo(
                    rt.savedAgents,
                    modules.proficiencyMetrics.savedAgents
                ),
                activePathname: rt.savedAgents
            },
            {
                label: searchTypes[rt.suggestedAgents].title,
                onClick: () => navTo(
                    rt.suggestedAgents,
                    modules.proficiencyMetrics.suggestedAgents
                ),
                activePathname: rt.suggestedAgents
            }
        ]
    },
});

const getAgentProductionNavItemsByApp = (navTo) => ({
    [appNames.XAM]: {
        label: agentProductionTerms.agentProduction,
        onClick: () => navTo(
            Routes.AGENT_PRODUCTION.BASE,
            moduleNames.agentProduction
        ),
        activePathname: Routes.AGENT_PRODUCTION.BASE
    },
    [appNames.XBM]: undefined,
});

const getMarketShareNavItemsByApp = (navTo) => ({
    [appNames.XAM]: {
        label: marketShareTerms.marketShare,
        menuItems: [
            { label: searchTerms.searchBy, header: true },
            {
                label: searchTypes[rt.totals].title,
                onClick: () => navTo(
                    rt.totals,
                    modules.marketShare.totals
                ),
                activePathname: rt.totals
            }
        ]
    },
    [appNames.XBM]: {

        label: marketShareTerms.marketShare,
        menuItems: [
            { label: searchTerms.searchBy, header: true },
            {
                label: searchTypes[rt.totals].title,
                onClick: () => navTo(
                    rt.totals,
                    modules.marketShare.totals
                ),
                activePathname: rt.totals
            },
            {
                label: searchTypes[rt.coverage].title,
                onClick: () => navTo(
                    rt.coverage,
                    modules.marketShare.coverage
                ),
                activePathname: rt.coverage
            }
        ]
    }
});
const getMarketDynamicsNavItems = (navTo) => ({
    label: marketDynamicsTerms.marketDynamics,
    onClick: () => navTo(
        Routes.MARKET_DYNAMICS.BASE,
        moduleNames.marketDynamics
    ),
    activePathname: Routes.MARKET_DYNAMICS.BASE
});

const getDashboardNavItems = (navTo) => ({
    label: terms.dashboard,
    onClick: () => navTo(
        Routes.HOME.DASHBOARD,
        moduleNames.dashboard
    ),
    activePathname: Routes.HOME.DASHBOARD,
});

export const getClientIdProvisionedForApp = (lwaClients, appCode) =>
    lwaClients?.find(client =>
        client.applications?.some(application => application.code === appCode)
    )?.clientId;

const getTalentNavItem = (lwaClients) => {
    const talentClientId = getClientIdProvisionedForApp(lwaClients, BMT_APP_KEY);
    if (!talentClientId) {
        return {
            label: talentTerms.talent,
            menuItems: [
                { label: talentTerms.tryTalent, url: TALENT_MARKETING_URL, target: '_blank' }
            ]
        };
    }

    return {
        label: talentTerms.talent,
        menuItems: [
            { label: talentTerms.tryTalent, url: `${talentUrl}?ac=${encodeURIComponent(talentClientId)}`, target: '_blank' }
        ]
    };
};

export const getUserItems = (navTo, isLegacyUser) => ([
    { url: '', label: navTerms.myProfile, onClick: () => navTo('/my-profile') },
    // {
    //     url: `${getEndpoint(ID_SITE)}/auth/realms/terradatum/login-actions/reset-credentials?client_id=aergo&tab_id=txRDXnWXhc0`,
    //     label: 'Reset Password'
    // },
    // LWA users sign out via the platform service's universal logout instead (see UniversalNavBar).
    ...(isLegacyUser ? [{ url: '#', label: navTerms.signOut, onClick: () => navigateToLogout() }] : []),
]);

// Pulled out of UniversalNavBar's effect so it's testable without mounting the component.
// Returns undefined when there's nothing new to show yet, so the caller can fall back.
export const resolveNavbarUserMenu = async ({ isLegacyUser, tokenInfo, platformService, userItems }) => {
    if (isLegacyUser) {
        return { userMenuProps: tokenInfo, menuItems: userItems || [] };
    }
    if (!platformService) return undefined;

    const navbarUserMenuProps = await platformService.getNavbarUserMenuProps({ menuItems: userItems });
    if (!navbarUserMenuProps) return undefined;

    return { userMenuProps: navbarUserMenuProps.user, menuItems: navbarUserMenuProps.menuItems || [] };
};

export const helpItems = [
    {
        url: 'https://www.lwolf.com/services/training/new-brokermetrics',
        label: helpItemLabels.WEBINARS_TRAINING,
        target: '_blank'
    },
    {
        url: 'https://lonewolf.my.site.com/s/brokermetrics-video-library',
        label: helpItemLabels.VIDEO_LIBRARY,
        target: '_blank'
    },
    {
        url: 'https://lwolf.force.com/s/article/BMPM-Proficiency-Metrics-FAQs',
        label: helpItemLabels.HELP_GUIDES_FAQS,
        target: '_blank'
    }
];

export const getNavItems = ({ allowedModules, navTo, isAgentProductionEnabled, isDashboardEnabled, isLegacyUser, isTalentEnabled, lwaClients }) => {
    const updatedNavItems = [];
    if (isDashboardEnabled) {
        updatedNavItems.push(getDashboardNavItems(navTo));
    }
    if (runningApp === appNames.XBM && !isLegacyUser && isTalentEnabled) {
        updatedNavItems.push(getTalentNavItem(lwaClients));
    }
    if (!allowedModules?.length || allowedModules.includes(moduleNames.proficiencyMetrics)) {
        updatedNavItems.push(getProficiencyMetricsNavItemsByApp(navTo)[runningApp]);
    }
    if (allowedModules?.includes(moduleNames.agentProduction) &&  isAgentProductionEnabled) {
        updatedNavItems.push(getAgentProductionNavItemsByApp(navTo)[runningApp]);
    }
    if (allowedModules?.includes(moduleNames.marketShare)) {
        updatedNavItems.push(getMarketShareNavItemsByApp(navTo)[runningApp]);
    }
    if (allowedModules?.includes(moduleNames.marketDynamics)) {
        updatedNavItems.push(getMarketDynamicsNavItems(navTo));
    }
    return updatedNavItems;
};

export const getProductURL = ({ product, userProducts, isSavedAgents=false, isLegacyUser=false }) => {
    const routeByProducts = {
        [moduleNames.proficiencyMetrics]: Routes.PROF_METRICS.BASE,
        [moduleNames.marketShare]: Routes.MARKET_SHARE.BASE,
        [moduleNames.marketDynamics]: Routes.MARKET_DYNAMICS.BASE
    };
    if (isLegacyUser && isSavedAgents) return Routes.PROF_METRICS.BASE + Routes.PROF_METRICS.SAVED_AGENTS;
    if (isLegacyUser) return Routes.PROF_METRICS.BASE
    if (isSavedAgents && userProducts?.includes(product)) {
        return Routes.PROF_METRICS.BASE + Routes.PROF_METRICS.SAVED_AGENTS;
    }
    if (userProducts?.includes(product)) return routeByProducts[product];
    return userProducts && userProducts.length > 0 ? routeByProducts[userProducts[0]] : undefined;
};
